// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__EeS98","spin":"Spinner_spin__Fr11V"};